import {createContext, useCallback, useContext, useState} from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

const MetaApiContext = createContext(null);

export function MetaApiProvider({children}) {
    const [isConnected, setIsConnected] = useState(false);
    const {post, get} = useApiService(CONFIG.SERVER_CHANNEL);

    const metaConnection = useCallback(async (code, redirectUri, channelId) => {
        try {
            const response = await post(`/v1/meta/token/long-lived`, {
                code: code,
                redirect_uri: redirectUri,
                channel_key: channelId
            });
            console.log("Meta token response:", response);
            if (response?.data?.status === "success") {
                 setIsConnected(true);
            }
            return response.data;
        } catch (error) {
            console.error("Error creating Connection:", error);
            throw error;
        }
    }, [post]);

    const getInstagramConstants = useCallback(async () => {
        try {
            const response = await get(
                `/v1/meta/constants/instagram`
            );
            console.log("Instagram constants response:", response);
            return response.data;
        } catch (error) {
            console.error("Error fetching Instagram constants:", error);
            throw error;
        }
    }, [get]);

    const getUserData = useCallback(async () => {
        try {
            const response = await get(
                "/v1/meta/user-data"
            );
            console.log("User data response:", response);
            return response.data;
        } catch (error) {
            console.error("Error fetching user data:", error);
            throw error;
        }
    }, [get]);

    const postDisconnect = useCallback(async (channelId) => {
        try {
            const response = await post(`/v1/meta/disconnect`, {
                channel_key: channelId
            });
            if (response?.data?.status === "success") {
              setIsConnected(false);
            }
            return response.data;
        } catch (error) {
            console.error("Error disconnecting:", error);
            throw error;
        }
    }, [post]);

    const getWhatsAppConstants = useCallback(async () => {
        try {
            const response = await get(
                `/v1/meta/constants/whats-app`
            );
            console.log("Whats App constants response:", response);
            return response.data;
        } catch (error) {
            console.error("Error fetching Whats App constants:", error);
            throw error;
        }
    }, [get]);

    return (
        <MetaApiContext.Provider value={{
            isConnected,
            getUserData,
            metaConnection,
            getInstagramConstants,
            postDisconnect,
            getWhatsAppConstants
        }}>
            {children}
        </MetaApiContext.Provider>
    );
}

export function useMetaApi() {
    const context = useContext(MetaApiContext);
    if (!context) {
        throw new Error("useMetaApi must be used within an MetaApiProvider");
    }
    return context;
}
